import { loadLink } from '../utils'

export const useCustomStylesheet = ({ href = 'resources/css/style.css', onloadFn }) => {
  loadLink({ href, onloadFn })
}
